export default __webpack_public_path__ + "static/media/intro-counter-background.443c63a6.png";